import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Button } from "@material-tailwind/react";
import { Link } from "react-router-dom";

const PoomReportsTable = () => {
  const [poomReportData, setPoomReportData] = useState([]);
  useEffect(() => {
    const collectionRef = collection(db, "report");

    const getPoomReportData = async () => {
      try {
        const data = await getDocs(collectionRef);
        setPoomReportData(
          data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        );
      } catch (error) {
        console.log(error);
      }
    };
    getPoomReportData();
  }, []);

  return (
    <>
      <div className="max-w-[1200px] mx-auto my-6 p-4">
        <h2 className="text-2xl font-bold py-2 text-center">Poom Reports:</h2>
      </div>
      <div className="grid gap-4 lg:grid-cols-1 place-items-center mb-6">
        {poomReportData.map((data, index) => {
          return (
            <>
              <div className="w-full p-2 rounded-lg shadow-xl lg:flex lg:max-w-lg py-6">
                <h4 className="text-xl font-semibold tracking-tight">
                  {index + 1}
                </h4>
                <div className="pl-6">
                  <p className="mt-1 leading-normal">
                    Reported Day: {data.reportedOn.toDate().toDateString()}
                  </p>
                  <p className="leading-normal">
                    Reported Time:{" "}
                    {data.reportedOn.toDate().toLocaleTimeString("en-US")}
                  </p>
                  <Link
                    to={`/reports/${data.id}`}
                    state={{ reportedFrom: `${data.reportedFrom}`, reporting: `${data.reporting}`, reason: `${data.content.reason}`, pid: `${data.content.pid}`, chatDocId: `${data.content.chatDocId}`, commentId: `${data.content.commentId}`}}
                  >
                    <Button
                      variant="outlined"
                      size="sm"
                      color="orange"
                      className="mt-2"
                    >
                      Read More!
                    </Button>
                  </Link>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default PoomReportsTable;
